import { Button, CircularProgress } from "@mui/material";
import axios from "axios";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import QRCode from "react-qr-code";
import { useLocation, useNavigate } from "react-router-dom";
import { useDecodedParams } from "../misc/utils";
import { useAws } from "../aws";
import { useRef } from "react";
import { PlayCircleOutlined } from "@mui/icons-material";
import PayMeLogo from "../assets/paycode_logo.png";
import payCodeLogo from "../assets/payCodeLogo.png";
import PayMeLogoWeb from "../assets/payme_logo_color_oneline.png";
import qrcode from "qrcode-generator";
import { drawPayCode } from "../misc/paycode";
import CreditCardInput from "react-credit-card-input";
import PaymentForm from "../component/PaymentForm";

const timeLimit = 600000;
const checkDuration = 5000; //should be 5000
// const timeLimit = 10000;

const QRCodePage = () => {
  const [payMeFlag, setPayMeFlag] = useState(false);
  const payCodeCanvas = useRef("");
  const { t } = useTranslation();
  const { type } = useDecodedParams();
  const navigate = useNavigate();
  const { x_api_key, x_api_key_cms } = useAws();
  const windowSize = useRef([window.innerWidth, window.innerHeight]);

  const [qrString, setQrString] = useState("");

  const [data, setData] = useState({});

  const [checkInterval, setCheckInterval] = useState(0);
  const [timerInterval, setTimerInterval] = useState(0);
  const [timer, setTimer] = useState(null);
  const ref = useRef(null);

  const {
    donationAmount,
    prefix,
    chineseLastname,
    chineseFirstname,
    englishLastname,
    englishFirstame,
    gender,
    confirmEmail,
    phoneType,
    phoneNumber,
    birthMonth,
    receiptName,
    receiptAddress,
  } = data;

  useEffect(() => {
    setData(() => {
      if (!type) {
        navigate(-1);
      } else if (type === "donation") {
        return JSON.parse(window.sessionStorage.getItem("donation"));
      } else if (type === "event") {
        return JSON.parse(window.sessionStorage.getItem("event"));
      }
    });
  }, [type]);

  const getDes = () => {
    if (type === "donation") {
      return `Donation - By ${englishFirstame} ${englishLastname}`;
    } else {
      if (type === "event") {
        return `Event enrollment - By ${englishFirstame} ${englishLastname}`;
      }
    }
  };

  useEffect(() => {
    if (data?.donationAmount && data?.donationAmount !== 0) {
      handleDonation();
    }
    if (data?.skuIndex != null && data?.skuIndex !== undefined && data?.optionIndex != null && data?.optionIndex !== undefined) {
      handleEventEnrollment();
    }
  }, [data]);

  const location = useLocation();

  const handleEventEnrollment = () => {
    axios
      .post(
        (process.env.REACT_APP_ENV == "DEV"
          ? "https://4kcdgeqkgf.execute-api.us-east-1.amazonaws.com/dev_pnb_public_api"
          : "https://boo7z0hhbk.execute-api.us-east-1.amazonaws.com/pnb_public_api_stage") +
          (data.paymentMethod == "FPS"
            ? "/user/create_payment_event"
            : data.paymentMethod == "PayMe"
            ? "/user/create_payment_payme_event"
            : "/user/create_payment_stripe_event"),
        processEventEnrollmentData(data),
        {
          headers: {
            "x-api-key": x_api_key,
            "Content-Type": "application/json",
          },
        }
      )
      .then((payment) => {
        if (data.NN2C) {
          console.log("NN2C");
          if (window.location.href.includes("/payment")) {
            navigate(`/result/2430e09`);
          }
          return;
        }
        if (!payment?.data?.body) {
          console.log("No data");
          return;
        }
        const { txnRef, qrCode, pId } = payment?.data?.body || {};
        if (data.paymentMethod === "PayMe") {
          update_qrcode(qrCode);
        } else if (data.paymentMethod === "FPS") {
          setQrString(qrCode);
        }
        startTimer();
        const checkPaymentStatus = setInterval(() => {
          axios
            .get((process.env.REACT_APP_ENV == "DEV" ? "https://4kcdgeqkgf.execute-api.us-east-1.amazonaws.com/dev_pnb_public_api" : "https://boo7z0hhbk.execute-api.us-east-1.amazonaws.com/pnb_public_api_stage") + "/user/paymentstatus", {
              params: {
                txnRef: txnRef,
                id: pId,
              },
              headers: {
                "x-api-key": x_api_key,
                "Content-Type": "application/json",
              },
            })
            .then((res) => {
              console.log(res);
              if (res?.data?.body?.status === "SUCCESS") {
                clearInterval(timerInterval);
                clearInterval(checkPaymentStatus);
                if (window.location.href.includes("/payment")) {
                  navigate(`/result/2430e09`);
                }
              } else if (res?.data?.body?.status === "FAIL") {
                clearInterval(timerInterval);
                clearInterval(checkPaymentStatus);
                if (window.location.href.includes("/payment")) {
                  navigate(`/result/fail`);
                }
              }
            });
        }, checkDuration);
        console.log(checkPaymentStatus);
        setCheckInterval(checkPaymentStatus);
        setTimeout(() => {
          clearInterval(timerInterval);
          clearInterval(checkPaymentStatus);
        }, timeLimit);
      });
  };
  const handleDonation = () => {
    axios
      .post(
        (process.env.REACT_APP_ENV == "DEV"
          ? "https://4kcdgeqkgf.execute-api.us-east-1.amazonaws.com/dev_pnb_public_api"
          : "https://boo7z0hhbk.execute-api.us-east-1.amazonaws.com/pnb_public_api_stage") +
          (data.paymentMethod == "FPS" ? "/user/create_payment_donation" : data.paymentMethod == "PayMe" ? "/user/create_payment_payme_donation" : ""),
        processDonationData(data),
        {
          headers: {
            "x-api-key": x_api_key,
            "Content-Type": "application/json",
          },
        }
      )
      .then((donationPayment) => {
        console.log(donationPayment);
        if (!donationPayment?.data?.body) {
          console.log("No data");
          return;
        }
        const { txnRef, qrCode, donationId } = donationPayment?.data?.body || {};
        if (data.paymentMethod === "PayMe") {
          update_qrcode(qrCode);
        } else if (data.paymentMethod === "FPS") {
          setQrString(qrCode);
        }

        startTimer();
        const checkPaymentStatus = setInterval(() => {
          axios
            .get((process.env.REACT_APP_ENV == "DEV" ? "https://4kcdgeqkgf.execute-api.us-east-1.amazonaws.com/dev_pnb_public_api" : "https://boo7z0hhbk.execute-api.us-east-1.amazonaws.com/pnb_public_api_stage") + "/user/paymentstatus", {
              params: {
                txnRef: txnRef,
                id: donationId,
              },
              headers: {
                "x-api-key": x_api_key,
                "Content-Type": "application/json",
              },
            })
            .then((res) => {
              console.log(res);
              if (res?.data?.body?.status === "SUCCESS") {
                clearInterval(timerInterval);
                clearInterval(checkPaymentStatus);
                if (window.location.href.includes("/donation")) {
                  navigate(`/donation/2430e09`);
                }
              } else if (res?.data?.body?.status === "FAIL") {
                clearInterval(timerInterval);
                clearInterval(checkPaymentStatus);
                if (window.location.href.includes("/donation")) {
                  navigate(`/donation/fail`);
                }
              }
            });
        }, checkDuration);
        console.log(checkPaymentStatus);
        setCheckInterval(checkPaymentStatus);
        setTimeout(() => {
          clearInterval(timerInterval);
          clearInterval(checkPaymentStatus);
        }, timeLimit);
      });
  };

  const startTimer = () => {
    setTimer(timeLimit);
    const updateTimer = setInterval(() => {
      setTimer((prev) => prev - 1000);
    }, 1000);
    setTimerInterval(updateTimer);
  };

  useEffect(() => {
    if (timer != null && timer <= 0) {
      clearInterval(timerInterval);
      clearInterval(checkInterval);
      if (window.location.href.includes("/payment")) {
        if (type === "event") {
          navigate(`/result/failed`);
        } else {
          navigate(`/donation/failed`);
        }
      }
    }
  }, [timer]);

  useEffect(() => {
    console.log(checkInterval);
  }, [checkInterval]);

  const processDonationData = (data) => {
    console.log(data);
    const p = {
      detail: {
        birth_month: parseInt(data.birthMonth.split("月")[0]),
        contact_email: data.confirmEmail,
        contact_phone: data.phoneNumber,
        contact_phone_region: data.phoneType || "",
        gender: data.gender,
        name: {
          en_first_name: data.englishFirstame,
          en_last_name: data.englishLastname,
          zh_first_name: data.chineseFirstname,
          zh_last_name: data.chineseLastname,
          prefix: data.prefix,
        },
      },
      amount: parseFloat(data.donationAmount),
      promo_terms: data["pi-1"] ? "yes" : "no",
      payment_method: data.paymentMethod,
      // The donor's chosen programme. Resolved server-side by id; the Card path
      // already sends this, FPS/PayMe silently dropped it (CMS showed "—").
      program_id: data.program || "ANY",
      receipt_info: {
        name: data.receiptName || " ",
        address: data.receiptAddress || " ",
      },
    };
    if (data.job) {
      p.detail.job = data.job;
    }
    return p;
  };

  const processEventEnrollmentData = (data) => {
    const p = {
      event_id: data.event_id,
      detail: {
        name: {
          prefix: data.prefix,
          zh_last_name: data.chineseLastname,
          zh_first_name: data.chineseFirstname,
          en_last_name: data.englishLastname,
          en_first_name: data.englishFirstame,
        },
        gender: data.gender,
        contact_email: data.confirmEmail,
        contact_phone: data.phoneNumber,
        contact_phone_region: data.phoneType || "",
        birth_year: parseInt(data.birthYear),
        birth_month: parseInt(data.birthMonth.split("月")[0]),
        address: data.livingArea,
        job: data.job,
        supporting_doc: data?.files?.length ? data.files.map((file) => file.data.filename) : [],
      },
      sku: data.skuIndex,
      option: data.optionIndex,
      promo_terms: data["pi-0"] ? "yes" : "no",
      film_terms: data["pi-1"] ? "yes" : "no",
      payment_method: data.paymentMethod,
    };
    return p;
  };

  // const printFormData = (event) => {
  //   if (event.key === "n") {
  //     // console.log("go");
  //     // console.log(checkInterval);
  //     // clearInterval(timerInterval);
  //     // clearInterval(checkInterval);
  //     // navigate(`/donation/2430e09`);
  //   }
  // };

  // useEffect(() => {
  //   document.removeEventListener("keydown", printFormData);
  //   document.addEventListener("keydown", printFormData);
  // }, [checkInterval]);

  const converTime = (ms) => {
    let s = ms / 1000;
    let secs = s % 60;
    s = (s - secs) / 60;
    var mins = s % 60;
    return (
      mins.toLocaleString("en-US", { minimumIntegerDigits: 2, useGrouping: false }) +
      ":" +
      secs.toLocaleString("en-US", { minimumIntegerDigits: 2, useGrouping: false })
    );
  };

  var create_qrcode = function (text, typeNumber, errorCorrectionLevel, mode, mb) {
    qrcode.stringToBytes = qrcode.stringToBytesFuncs[mb];
    if (typeNumber === 0) {
      typeNumber = suggestTypeNumber(text);
    }

    var qr = qrcode(typeNumber || 4, errorCorrectionLevel || "M");
    qr.addData(text, mode);
    qr.make();
    console.log(qr);
    return qr;
  };

  var suggestTypeNumber = function (text) {
    var length = text.length;
    if (length <= 32) {
      return 3;
    } else if (length <= 46) {
      return 4;
    } else if (length <= 60) {
      return 5;
    } else if (length <= 74) {
      return 6;
    } else if (length <= 86) {
      return 7;
    } else if (length <= 108) {
      return 8;
    } else if (length <= 130) {
      return 9;
    } else if (length <= 151) {
      return 10;
    } else if (length <= 177) {
      return 11;
    } else if (length <= 203) {
      return 12;
    } else if (length <= 241) {
      return 13;
    } else if (length <= 258) {
      return 14;
    } else if (length <= 292) {
      return 15;
    } else {
      return 40;
    }
  };

  const paymeLogoImgElement = useRef("");

  var update_qrcode = function (text) {
    setPayMeFlag(true);
    console.log(payCodeCanvas.current);
    var t = 0;
    var e = "Q";
    var m = "Byte";
    var mb = "UTF-8";
    var qr = create_qrcode(text, t, e, m, mb);
    var size = "224";
    var consumer = false;

    var canvas = payCodeCanvas.current;
    console.log(payCodeCanvas);
    var ctx = canvas.getContext("2d");

    canvas.width = size;
    canvas.height = size;
    ctx.setTransform(1, 0, 0, 1, 0, 0);
    ctx.clearRect(0, 0, canvas.width, canvas.height);
    console.log(paymeLogoImgElement.current);
    drawPayCode(qr, canvas, 7, paymeLogoImgElement.current, consumer);
  };

  console.log(data.payment_id);
  return (
    <div className="page-view event-detail">
      <img className="logo mt-2 mb-6" src="/logoPNB.png" alt="pause-and-breathe-logo" />
      <form>
        <div className={`card-view donation-card donation-result-card`} style={{ marginBottom: "40px" }}>
          {data.paymentMethod === "PayMe" ? <img src={PayMeLogoWeb} width="250"></img> : null}
          {data.NN2C || data.paymentMethod != "FPS" ? null : <h1 className="mt-2 mb-1 ml-2">{t("FPS Payment")}</h1>}
          {data.NN2C || data.paymentMethod != "Card" ? null : <h1 className="mt-2 mb-1 ml-2">{t("Card Payment")}</h1>}
          {data.NN2C ? null : (
            <h4 className="ml-2" style={{ textAlign: "center" }}>
              {data.paymentMethod == "FPS" ? t("QR code title") : data.paymentMethod == "PayMe" ? t("PayCode title") : t("Card title")}
            </h4>
          )}
          {data.paymentMethod === "PayMe" ? <img ref={paymeLogoImgElement} src={payCodeLogo} width="100" height="100" style={{ display: "none" }} /> : null}
          <div className="qr-box">
            <canvas ref={payCodeCanvas} width="344" height="344" style={payMeFlag ? {} : { display: "none" }}></canvas>
            {data.paymentMethod == "Card" ? (
              <>
                {/* <h4>{converTime(timer)}</h4> */}
                <PaymentForm payment_id={data.payment_id} type={type} windowSize={windowSize} donationData={data} />
              </>
            ) : (
              <>
                {payMeFlag === false && qrString === "" ? (
                  <>
                    <CircularProgress sx={{ margin: "20px 0" }} />
                    {data.NN2C ? null : <h4>{data.paymentMethod == "FPS" ? t("Please wait FPS") : t("Please wait PayMe")}</h4>}
                  </>
                ) : (
                  <>
                    <div>
                      {data.paymentMethod == "FPS" ? (
                        <QRCode size={1024} style={{ height: "auto", maxWidth: "100%", width: "100%" }} value={qrString} viewBox={`0 0 1024 1024`} />
                      ) : (
                        // <QRCode size={1024} style={{ height: "auto", maxWidth: "100%", width: "100%" }}
                        // value={qrString} viewBox={`0 0 1024 1024`} fgColor="#c92a23"/>
                        // <canvas ref={payCodeCanvas} width="344" height="344"></canvas>
                        <></>
                      )}
                    </div>
                    <>
                      <h4>{converTime(timer)}</h4>
                      {type === "event" ? <h4>{t("Please scan - Event")}</h4> : <h4>{t("Please scan - Donation")}</h4>}
                    </>
                    {data.paymentMethod == "FPS" ? (
                      <>
                        <div className="info-block">
                          <h4>{t("Don't close")}</h4>
                        </div>
                        <div className="list-block">
                          <ol>
                            <li>{t("QR payment 1")}</li>
                            <li>
                              <div>
                                {t("QR payment 2")}
                                <br />
                                <span className="info-text">{t("QR payment 2 info")}</span>
                              </div>
                            </li>
                            <li>
                              <div>
                                {t("QR payment 3")}
                                <br />
                                <span className="info-text">{t("QR payment 3 info")}</span>
                              </div>
                            </li>
                          </ol>
                        </div>
                      </>
                    ) : (
                      <>
                        <div className="info-block">
                          <h4>{t("Don't close")}</h4>
                        </div>
                        <div className="list-block">
                          <ol>{t("QR payment 0 PayMe")}</ol>
                          <ol>
                            <li>{t("QR payment 1 PayMe")}</li>
                            <li>
                              <div>{t("QR payment 2 PayMe")}</div>
                            </li>
                            <li>
                              <div>{t("QR payment 3 PayMe")}</div>
                            </li>
                          </ol>
                        </div>
                      </>
                    )}
                  </>
                )}
              </>
            )}
          </div>
        </div>
        <div className={`my-5 btns-gp-div`}>
          {/* <Button
            sx={{ marginRight: 2 }}
            onClick={() => {
              navigate(-2);
            }}
          >
            {t("Back")}
          </Button> */}
        </div>
      </form>
    </div>
  );
};

export default QRCodePage;
